import _ from 'lodash';
import $ from "jquery";
import moment from 'moment';
import excelExport from 'table2excel/dist/table2excel';
import csvExport from 'table2csv/dist/table2csv';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import FooTable from 'footable';

class PaylocityController {
  constructor($rootScope, $http, toastr) {
    "ngInject";
    this.name = 'reports';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.reports = [];
    this.toastr = toastr;
    this.oldValues = {}; // Store old values for comparison
    this.secretUpdateCode = '';
    this.updatingClientSecret = false;
    this.connected = 'Not Connected';
    this.paylocityIntegration = {};

    let self = this;

    let style = [
      {textCls: 'text-info', btnCls: 'btn-info'},
      {textCls: 'text-success', btnCls: 'btn-success'},
      {textCls: 'text-warning', btnCls: 'btn-warning'},
      {textCls: 'text-danger', btnCls: 'btn-danger'}
    ]


    $http.get($rootScope.apiHost+"/api/integrations/paylocity/status", {withCredentials: true}).then(function (success) {
      self.paylocityIntegration = success.data;
    });

    $http.get($rootScope.apiHost+"/api/integrations/paylocity/authenticate", {withCredentials: true}).then(function (success) {
      self.connected = 'Connected';
    }, function (failure) {
      self.connected = 'Not Connected';
    });

  }



  activeToggle() {
    this.updatePaylocityIntegrationDetails("enabled", this.paylocityIntegration.enabled, "Integration Status");
  }

  storeOldValue(parameter) {
    // Store the old value before xeditable updates it
    this.oldValues[parameter] = this.paylocityIntegration[parameter];
  }

  updatePaylocityIntegrationDetails(parameter, value, fieldName) {
    let self = this;
    
    // Get the old value that was stored before xeditable updated the model
    const oldValue = this.oldValues[parameter];
    
    // Check if the value actually changed
    if (oldValue === value) {
      // Value hasn't changed, don't make the REST call
      // Clear the stored old value
      delete this.oldValues[parameter];
      return;
    }
    
    let obj = {};
    obj[parameter] = value;

    // Field name mapping for better toast messages
    const fieldNames = {
      'paylocityCompanyId': 'Company ID',
      'clientId': 'OAuth Client ID',
      'clientSecret': 'OAuth Client Secret',
      'enabled': 'Integration Status'
    };
    
    const displayName = fieldName || fieldNames[parameter] || parameter;

    this.$http.patch(this.$rootScope.apiHost+"/api/integrations/paylocity", obj, {withCredentials: true}).then(function (success) {
      self.toastr.success(displayName + " successfully updated.", "Success");
      // Refresh the integration status to get updated data
      self.$http.get(self.$rootScope.apiHost+"/api/integrations/paylocity/status", {withCredentials: true}).then(function (success) {
        self.paylocityIntegration = success.data;
      });
      // Clear the stored old value
      delete self.oldValues[parameter];
    }, function (failure) {
      self.toastr.error("Could not update " + displayName + ".", "ERROR");
      // Restore the old value on error
      self.paylocityIntegration[parameter] = oldValue;
      delete self.oldValues[parameter];
    });
  }

  testPaylocityConection() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost+"/api/integrations/paylocity/authenticate", {withCredentials: true}).then(function (success) {
      self.connected = 'Connected';
      self.toastr.success("Successfully Connected.", "Success");
      self.refreshPaylocityStatus();
    }, function (failure) {
      self.connected = 'Not Connected';
      self.toastr.error("Could not Authenticate.", "ERROR");
    });
  }

  formatSecretExpiration(value) {
    if (!value) {
      return '';
    }
    const parsed = moment(value);
    if (parsed.isValid()) {
      return parsed.format('MMM DD, YYYY');
    }
    return value;
  }

  refreshPaylocityStatus() {
    let self = this;
    return this.$http.get(this.$rootScope.apiHost + "/api/integrations/paylocity/status", { withCredentials: true }).then(function (success) {
      self.paylocityIntegration = success.data || {};
      return self.paylocityIntegration;
    });
  }

  refreshConnectionStatus() {
    let self = this;
    return this.$http.get(this.$rootScope.apiHost + "/api/integrations/paylocity/authenticate", { withCredentials: true }).then(function () {
      self.connected = 'Connected';
    }, function () {
      self.connected = 'Not Connected';
    });
  }

  updatePaylocityApiSecret() {
    let self = this;
    const code = (this.secretUpdateCode || '').trim();
    if (!code || this.updatingClientSecret) {
      return;
    }

    this.updatingClientSecret = true;
    this.$http.post(
      this.$rootScope.apiHost + "/api/integrations/paylocity/secret",
      { code: code },
      { withCredentials: true }
    ).then(function (success) {
      self.paylocityIntegration = success.data || self.paylocityIntegration;
      self.secretUpdateCode = '';
      self.toastr.success("Paylocity API secret updated successfully.", "Success");
      return self.refreshConnectionStatus();
    }, function (failure) {
      const message = (failure.data && (failure.data.message || failure.data.error))
        || "Could not update the Paylocity API secret. Verify the code and try again.";
      self.toastr.error(message, "ERROR");
    }).finally(function () {
      self.updatingClientSecret = false;
    });
  }

  syncEmployeeData() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost+"/api/integrations/paylocity/sync/employee", {withCredentials: true}).then(function (success) {
      self.$http.get(self.$rootScope.apiHost+"/api/integrations/paylocity/status", {withCredentials: true}).then(function (success) {
        self.paylocityIntegration = success.data;
      });
    }, function (failure) {
      self.toastr.error("Problem Synching Data.", "ERROR");
    });
  }

  importEmployeeCache() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost+"/api/integrations/paylocity/import/employeecache", {withCredentials: true}).then(function (success) {
      self.toastr.success("Paylocity Employees Successfully Imported.", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Problem Synching Data.", "ERROR");
    });
  }

  rollupPayroll() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost+"/api/integrations/paylocity/rollup/payroll", {withCredentials: true}).then(function (success) {
      self.toastr.success("Paylocity Employees Successfully Imported.", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Problem Synching Data.", "ERROR");
    });
  }

  syncPayrollData() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost+"/api/integrations/paylocity/import/payroll", {withCredentials: true}).then(function (success) {
      self.$http.get(self.$rootScope.apiHost+"/api/integrations/paylocity/status", {withCredentials: true}).then(function (success) {
        self.paylocityIntegration = success.data;
      });
    }, function (failure) {
      self.toastr.error("Problem Synching Data.", "ERROR");
    });
  }

}

export default PaylocityController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/paylocity.controller.js